export function getFilterParams(filter) {

  const currentFilter = document.querySelector('.content_filter')
  let hashes = filter.slice(filter.indexOf('?') + 1).split('&')


  hashes.reduce((params, hash) => {

    let selectedElem

    let [key, val] = hash.split('=')
      if(key === 'filter') {
      	const filter = val.replace(/%20/g, '-')
        const elem = '.filter_' + filter
        selectedElem = document.querySelector(elem)
        selectedElem.classList.add('filter-selected')
      } else if (currentFilter){
        selectedElem = currentFilter.querySelector('.filter_all').classList.add('filter-selected')
      }
  }, {})

}

export function flipContentPosition(elem, idx) {
  const pos = ((idx % 2) === 0) ? 'grid-pos-right' : 'grid-pos-left'
  elem.classList.add(pos)
}

export function withinRange(value, min, max) {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}

export function returnImageBrightness(el, img) {

    if(!el) {
      return
    }

    const playground = document.querySelector('.canvas-calc-area')
    const crumbs = document.querySelector('.breadcrumb')

    const imgEl = new Image();
    imgEl.src = img;


    imgEl.onload = () => {

      playground.appendChild(imgEl);

      let blockSize = 5,
          canvas = document.createElement('canvas'),
          context = canvas.getContext && canvas.getContext('2d'),
          data, width, height,
          i = -4,
          length,
          rgb = {r:0,g:0,b:0},
          count = 0

          if (!context) {
              return rgb
          }

          height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height
          width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width

          playground.appendChild(canvas)
          context.drawImage(imgEl, 0, 0)


          try {
              data = context.getImageData(0, 0, width, height)
          } catch(e) {
              return rgb
          }

          length = data.data.length

          while ( (i += blockSize * 4) < length ) {
              ++count
              rgb.r += data.data[i]
              rgb.g += data.data[i+1]
              rgb.b += data.data[i+2]
          }

          rgb.r = ~~(rgb.r/count)
          rgb.g = ~~(rgb.g/count)
          rgb.b = ~~(rgb.b/count)


          const brightness = 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b
          const classCol = (brightness<180) ? 'light' : 'dark'

          if(crumbs) {
            crumbs.classList.add(classCol)
          }

          el.classList.add(classCol)
      }
}

export function buyNowPopup ( buttons ) {
    if( !buttons ) {
        return
    }

    let currentProduct = ''

    document.removeEventListener('click', clickAway)
    document.addEventListener('click', clickAway)

    buttons.forEach(function ( el, i ) {
        if (el.getAttribute('listener') !== 'true') {
            el.addEventListener('click', clickFunc, true)
            el.setAttribute('listener', 'true');
        }
    })

    function clickAway ( e ) {
        if (e.target.closest('.buyNowPopup') || e.target.closest('.buy-now__popup')) {
            return
        }

        removeAllBuyNowPopups()
    }

    function clickFunc ( e ) {
        toggleBuyNowPopup( e.target )
        currentProduct = e.target.dataset.product
    }

    function toggleBuyNowPopup ( el ) {
        let popup = el.previousElementSibling
        if ( popup.classList.contains('show') ) {
            removeBuyNowPopup( popup )
        } else {
            removeAllBuyNowPopups()
            popup.classList.add('show')
        }
    }

    function removeBuyNowPopup ( popup ) {
        popup.classList.add('hide')
        popup.classList.remove('show')

        setTimeout(function () {
            popup.classList.remove('hide')
        }, 200)
    }

    function removeAllBuyNowPopups () {
        buttons.forEach(function ( button ) {
            let popup = button.previousElementSibling
            removeBuyNowPopup( popup )
        })
    }

    let shopLinks = Array.from(document.querySelectorAll('.shop-link'))
    if ( shopLinks.length > 0 ) {
      shopLinks.forEach((e) => {
        e.addEventListener('click', (el)=> {
          trackEvent({ type: 'product', ev: 'external-shop-link', val: `${currentProduct} : ${el.target.dataset.store.toUpperCase()}`})
        })
      })
    }


}

export function trackEvent (data) {
  if (window.ga !== undefined) {
    let tracker = window.ga.getAll()[0]
    tracker.send('event', data.type, data.ev, data.val)
  }
}

export function skipContent (el) {

  let direction = el.classList.contains('up') ? 'up' : 'down'
  let bounds = el.parentNode.getBoundingClientRect()

  el.addEventListener('click', (e)=> {
    let dist = bounds.height
    let dir = (direction === 'up') ? dist*-1 : dist
    scrollAnim(dir, 300)
  })
}

const scrollAnim = (distance, duration) => {

    let initialY = document.body.scrollTop
    let y = initialY + distance
    let baseY = (initialY + y) * 0.5
    let difference = initialY - baseY
    let startTime = performance.now()

    function step() {
        let normalizedTime = (performance.now() - startTime) / duration
        if (normalizedTime > 1) normalizedTime = 1

        window.scrollTo(0, baseY + difference * Math.cos(normalizedTime * Math.PI))
        if (normalizedTime < 1) window.requestAnimationFrame(step)
    }
    window.requestAnimationFrame(step)
}


export function languageChoice ( el ) {
    let choices = el.nextElementSibling

    el.addEventListener('click', ()=> {
        el.classList.toggle('open')
        if ( choices.classList.contains('show') ) {
            choices.classList.remove('show')
        } else {
            choices.classList.add('show')
        }
    })
}



// WEBPACK FOOTER //
// ./src/utils.js